const state = {
  sidebarOpen: false,
  theme: 'light',
  mobileMenuOpen: false,
  windowWidth: window.innerWidth,
  scrollPosition: 0
}

const getters = {
  isSidebarOpen: state => state.sidebarOpen,
  currentTheme: state => state.theme,
  isMobileMenuOpen: state => state.mobileMenuOpen,
  isMobile: state => state.windowWidth < 768,
  isTablet: state => state.windowWidth >= 768 && state.windowWidth < 1024,
  isDesktop: state => state.windowWidth >= 1024,
  scrollPosition: state => state.scrollPosition
}

const mutations = {
  TOGGLE_SIDEBAR(state) {
    state.sidebarOpen = !state.sidebarOpen
  },

  SET_SIDEBAR(state, isOpen) {
    state.sidebarOpen = isOpen
  },

  TOGGLE_MOBILE_MENU(state) {
    state.mobileMenuOpen = !state.mobileMenuOpen
  },

  SET_MOBILE_MENU(state, isOpen) {
    state.mobileMenuOpen = isOpen
  },

  SET_THEME(state, theme) {
    state.theme = theme
    localStorage.setItem('preferred-theme', theme)
    document.documentElement.setAttribute('data-theme', theme)
  },

  SET_WINDOW_WIDTH(state, width) {
    state.windowWidth = width

    // Auto-close mobile menu on desktop
    if (width >= 1024) {
      state.mobileMenuOpen = false
    }
  },

  SET_SCROLL_POSITION(state, position) {
    state.scrollPosition = position
  }
}

const actions = {
  toggleSidebar({ commit }) {
    commit('TOGGLE_SIDEBAR')
  },

  setSidebar({ commit }, isOpen) {
    commit('SET_SIDEBAR', isOpen)
  },

  toggleMobileMenu({ commit }) {
    commit('TOGGLE_MOBILE_MENU')
  },

  setMobileMenu({ commit }, isOpen) {
    commit('SET_MOBILE_MENU', isOpen)
  },

  setTheme({ commit }, theme) {
    commit('SET_THEME', theme)
  },

  initializeTheme({ commit }) {
    const savedTheme = localStorage.getItem('preferred-theme')
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches
    const theme = savedTheme || (prefersDark ? 'dark' : 'light')

    commit('SET_THEME', theme)
  },

  handleResize({ commit }) {
    const updateWidth = () => {
      commit('SET_WINDOW_WIDTH', window.innerWidth)
    }

    let timeoutId
    const debouncedUpdate = () => {
      clearTimeout(timeoutId)
      timeoutId = setTimeout(updateWidth, 150)
    }

    window.addEventListener('resize', debouncedUpdate)
    updateWidth() // Initial call

    // Return cleanup function
    return () => {
      window.removeEventListener('resize', debouncedUpdate)
      clearTimeout(timeoutId)
    }
  },

  handleScroll({ commit }) {
    const updateScrollPosition = () => {
      commit('SET_SCROLL_POSITION', window.scrollY)
    }

    let ticking = false
    const requestTick = () => {
      if (!ticking) {
        requestAnimationFrame(updateScrollPosition)
        ticking = true
        setTimeout(() => { ticking = false }, 16) // ~60fps
      }
    }

    window.addEventListener('scroll', requestTick, { passive: true })
    updateScrollPosition() // Initial call

    // Return cleanup function
    return () => {
      window.removeEventListener('scroll', requestTick)
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
